module.exports = __webpack_public_path__ + "static/img/lx.ebc307fc.png";